/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	// <IRトップ> 最新決算資料一括ダウンロード
	const latestPdfDownload = () => {
		const handleDownload = (name) => {
			// IE
			if(window.navigator.msSaveBlob) {
				let xhr = new XMLHttpRequest();
				xhr.open('GET', name, true);
				xhr.responseType = 'blob';
				xhr.onload = (e) => {
					let blob = xhr.response;
					window.navigator.msSaveBlob(blob, name);
				};
				xhr.send();
				return;
			}

			// chrome,firefox
			let $downloadItem = document.createElement('a');
			$downloadItem.download = name;
			$downloadItem.href = name;

			document.body.appendChild($downloadItem);
			$downloadItem.click();
			document.body.removeChild($downloadItem);
		};

		const multi_download = () => {
			$('.js-download-item').each((idx, ele) => {
				let $item = $(ele).attr('href');
				handleDownload($item);
			});
		};

		$('.js-download-btn').on('click', () => {
			multi_download();
		});
	};


	/*--------------------------------------------------------------------------*/
	if($('.js-download-btn').length) {
		latestPdfDownload();
	}
	if($('html').hasClass('opacity')) {
		$('html').removeClass('opacity');
	}

})(window.jQuery, window.FUNCTIONS);